define('areas/activityfeedconfigurator/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var ActivityFeedConfiguratorVM = (function () {
        function ActivityFeedConfiguratorVM() {
        }
        return ActivityFeedConfiguratorVM;
    }());
    exports.ActivityFeedConfiguratorVM = ActivityFeedConfiguratorVM;
});

